import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import './Badge.css';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  /** Render a small leading dot. Use when color alone would carry meaning. */
  dot?: boolean;
  /** Leading icon (16px). Preferred over `dot` for state clarity. */
  icon?: ReactNode;
  className?: string;
}

/**
 * Compact label for lifecycle, role, counts, and tags. Semantic tones map to the
 * state palette; pair tone with an icon or dot so meaning never rests on color
 * alone (accessibility floor). For agent/run state prefer {@link StatusPill}.
 */
export function Badge({ children, tone = 'neutral', dot, icon, className }: BadgeProps): JSX.Element {
  return (
    <span className={cn('badge', `badge--${tone}`, className)}>
      {dot && <span className="badge__dot" aria-hidden="true" />}
      {icon && (
        <span className="badge__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      {children}
    </span>
  );
}
